import React, {useContext} from 'react';
import {clsx} from 'clsx';
import {Button, Typography} from 'onboarding-components';

import {handleCompleteStep} from 'common/onboarding/immersive-onboarding/utils';
import {TrackingEvent} from 'common/onboarding/immersive-onboarding/tracking';
import {SetupGuideContext, Step} from 'common/onboarding/immersive-onboarding/types';
import {useTranslation} from 'common/i18n/hooks';
import common from 'iron/common/onboarding/immersive-onboarding/steps/common.module.styl';

import {ExistingTools} from './ExistingTools';

export const ConnectExistingTool = () => {
  const {setStep, setupGuideInfo, setSetupGuideInfo, setSelectAltSDK} = useContext(SetupGuideContext);
  const {t} = useTranslation();

  const handleGoBack = () => {
    handleCompleteStep({
      setupGuideInfo,
      setSetupGuideInfo,
      setStep,
      completedStep: Step.GetStarted,
      nextStep: Step.GetStarted,
      trackingEvent: TrackingEvent.ReturnToStart,
    });
  };

  const handleVerifyConnection = () => {
    handleCompleteStep({
      setupGuideInfo,
      setSetupGuideInfo,
      setStep,
      completedStep: Step.Connect,
      nextStep: Step.Verify,
      trackingEvent: TrackingEvent.VerifyConnection,
    });

    setSelectAltSDK(false);
  };

  return (
    <div className={common.container}>
      <header className={common.mb16}>
        <Typography className={common.mb8} variant='captionXs' weight='bold'>
          {t(`onboarding.connect.integrations`)}
        </Typography>
        <Typography className={clsx(common.mt0, common.mb8)} variant='headingSm'>
          {t(`onboarding.welcome.connect-with-existing-tool`)}
        </Typography>
        <Typography variant='bodySm'>{t(`onboarding.connect.integrations-description`)}</Typography>
      </header>

      <ExistingTools />

      <div className={clsx(common.buttonGroup, common.mt16)}>
        <Button variant='transparent' size='small' onClick={handleGoBack}>
          {t(`onboarding.sidenav.go-back`)}
        </Button>
        <Button variant='solid' size='small' onClick={handleVerifyConnection}>
          {t(`onboarding.sidenav.verify-connection`)}
        </Button>
      </div>
    </div>
  );
};
